//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LabeledControlLayout from '@/components/shared/labeled-control-layout'
import ForgotPasswordDialog from '@/frontend/components/common/forgot-password-dialog-layout'
import {mapActions, mapState} from 'vuex'
import {getShoppingCartSID} from '@/utils/helpers'

export default {
  name: 'UserLogin',
  components: {
    LabeledControlLayout,
    ForgotPasswordDialog,
  },
  props: {
    redirectTo: {
      type: String,
      required: false,
      default: 'home',
    },
  },
  data() {
    return {
      signInForm: {
        data: {
          email: '',
          password: '',
        },
        emailRules: [
          (v) => !!v || 'This is a required field',
          /* (v) =>
            /.+@.+\..+/.test(v) ||
            this.$t('Please enter a valid email address') */
        ],
        rules: {
          required: (value) => !!value || 'This is a required field',
          min: (v) => (v && v.length >= 8) || 'Min 8 characters',
        },
        rememberMe: false,
        valid: false,
      },
      forgotPasswordDialogVisibility: false,
    }
  },
  computed: {
    ...mapState('common/cache', ['loadSettings']),
  },
  methods: {
    ...mapActions('common/cache', ['loadingCache']),
    async signIn() {
      if (this.$refs.signInForm.validate()) {
        try {
          const response = await this.$auth.loginWith('local', {
            data: {
              username: this.signInForm.data.email,
              password: this.signInForm.data.password,
              sessionId: getShoppingCartSID(),
            },
          })

          if (response.status === 200 && response.data.token) {
            this.$toast.success('Logged in!')
            this.$store.dispatch('shoppingCart/frontendGetBySessionId')
            await this.loadingCache()
            
            const redirect = this.$nuxt.context.from
              ? this.$nuxt.context.from.fullPath
              : this.redirectTo
            
            await this.$router.push(redirect)
          } else {
            this.$toast.error('Invalid username or password!')
          }
        } catch (err) {
          console.log(err)
          this.$toast.error('Error while login in!')
        }
      }
    },
    showDialog() {
      this.forgotPasswordDialogVisibility = true
    },
    closeDialog() {
      this.forgotPasswordDialogVisibility = false
    },
  },
}
